// Mock data for WYSE Tribe

export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Cases', path: '/cases' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contact', path: '/contact' },
];

export const tribeLinks = [
  { label: 'WYSE Tribe', href: '#' },
  { label: 'WYSE Tribe', href: '/' },
  { label: 'WYSE Wealth', href: '#' },
  { label: 'WYSE Insure', href: '#' },
  { label: 'WYSE Realty', href: '#' },
];

export const heroHighlights = [
  { id: 1, icon: 'BadgeCheck', titleKey: 'hl.expert.title', textKey: 'hl.expert.text' },
  { id: 2, icon: 'BarChart3', titleKey: 'hl.consulting.title', textKey: 'hl.consulting.text' },
  { id: 3, icon: 'Calculator', titleKey: 'hl.planning.title', textKey: 'hl.planning.text' },
];

export const aboutBullets = [
  'CRA-certified specialists',
  'Transparent fixed pricing',
  'Year-round tax support',
  'Cross-border expertise',
  'Audit representation',
  'Confidential & secure',
];

export const stats = [
  { id: 1, value: 4200, suffix: '+', labelKey: 'stats.clients', icon: 'Users' },
  { id: 2, value: 9800, suffix: '+', labelKey: 'stats.returns', icon: 'FileCheck' },
  { id: 3, value: 18, suffix: '+', labelKey: 'stats.years', icon: 'Trophy' },
  { id: 4, value: 32, suffix: '+', labelKey: 'stats.experts', icon: 'UserCheck' },
];

export const services = [
  {
    id: 'personal-tax',
    slug: 'personal-tax',
    icon: 'Receipt',
    title: 'Personal Tax Filing',
    short: 'Maximise refunds with accurate, CRA-compliant personal returns.',
    description:
      'From T4 employees to self-employed contractors, we handle every Canadian personal return with care. We identify every eligible deduction and credit so you keep more of what you earn.',
  },
  {
    id: 'corporate-tax',
    slug: 'corporate-tax',
    icon: 'Building2',
    title: 'Corporate Tax',
    short: 'T2 filings, year-end planning and tax-efficient structures.',
    description:
      'Strategic corporate tax planning, T2 returns, GST/HST filings, and CRA correspondence handled end-to-end so your business can focus on growth.',
  },
  {
    id: 'audit-assurance',
    slug: 'audit-assurance',
    icon: 'ShieldCheck',
    title: 'Audit & Assurance',
    short: 'Confident CRA audit representation and reviewed financials.',
    description:
      'Sleep easy knowing our audit specialists represent you directly with the CRA. We prepare documentation, negotiate outcomes and protect your position.',
  },
  {
    id: 'bookkeeping',
    slug: 'bookkeeping',
    icon: 'BookOpen',
    title: 'Bookkeeping',
    short: 'Clean books, monthly reports and cloud-first workflows.',
    description:
      'Monthly bookkeeping with QuickBooks and Xero integration, payroll, bank reconciliations and management reports that actually make sense.',
  },
  {
    id: 'cross-border',
    slug: 'cross-border',
    icon: 'Globe2',
    title: 'Cross-Border Tax',
    short: 'Canada\u2013US returns, FBAR and treaty optimization.',
    description:
      'US-Canada cross-border filings, FBAR, FATCA, treaty positions and expat planning. We make dual filings simple and compliant.',
  },
  {
    id: 'financial-planning',
    slug: 'financial-planning',
    icon: 'TrendingUp',
    title: 'Financial Planning',
    short: 'RRSP, TFSA, retirement and estate strategies that compound.',
    description:
      'A complete plan covering investments, retirement, insurance and estate \u2013 aligned with your tax position so every dollar works harder.',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    role: 'Founder, Northway Studio',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80&auto=format&fit=crop',
    quote:
      'WYSE Tribe restructured our corporation and saved us nearly $22k in the first year. They explain everything in plain English \u2013 a rare find in this industry.',
  },
  {
    id: 2,
    name: 'Marcus Lee',
    role: 'Self-Employed Consultant',
    avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=200&q=80&auto=format&fit=crop',
    quote:
      'Switched from a big-box tax shop and never looking back. My filings are sharper, my refund was higher, and I actually know what was claimed and why.',
  },
  {
    id: 3,
    name: 'Aisha Patel',
    role: 'Real Estate Investor',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&q=80&auto=format&fit=crop',
    quote:
      'They handle three corporations and my personal returns. Proactive, responsive, and always one step ahead of the CRA.',
  },
  {
    id: 4,
    name: 'Jonathan Reyes',
    role: 'US/Canada Expat',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80&auto=format&fit=crop',
    quote:
      'Cross-border filing used to be a nightmare. WYSE Tribe made it boring \u2013 in the best possible way.',
  },
];

export const cases = [
  {
    id: 1,
    slug: 'short-range-tax-planning',
    title: 'Short-Range Tax Planning',
    summary:
      'Year-end optimization for a Toronto-based agency, reducing tax payable by 28% in a single fiscal year.',
    image:
      'https://images.unsplash.com/photo-1714974528683-8940bd8311aa?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    category: 'Corporate',
  },
  {
    id: 2,
    slug: 'purposive-tax-planning',
    title: 'Purposive Tax Planning',
    summary:
      'Structured a family trust and holding company for a multi-generational client to compound wealth tax-efficiently.',
    image:
      'https://images.unsplash.com/photo-1714974528692-31aff2c54a62?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    category: 'Family Office',
  },
  {
    id: 3,
    slug: 'permissive-tax-planning',
    title: 'Permissive Tax Planning',
    summary:
      'Leveraged every CRA-allowed credit and deduction for a self-employed creator, increasing refund by $14,800.',
    image:
      'https://images.unsplash.com/photo-1758519288480-1489c17b1519?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    category: 'Personal',
  },
  {
    id: 4,
    slug: 'cross-border-restructure',
    title: 'Cross-Border Restructure',
    summary:
      'Untangled a 5-year US/Canada filing backlog for a returning expat with zero penalties owed.',
    image:
      'https://images.pexels.com/photos/6779565/pexels-photo-6779565.jpeg?auto=compress&cs=tinysrgb&w=900',
    category: 'Cross-Border',
  },
];

export const faqs = [
  {
    id: 1,
    q: 'How quickly can WYSE Tribe file my personal return?',
    a: 'For straightforward T1 returns we typically file within 3 business days of receiving your documents. Complex returns with self-employment, rental or investment income are completed within 7\u201310 business days.',
  },
  {
    id: 2,
    q: 'Do you support both QuickBooks and Xero for bookkeeping?',
    a: 'Yes. Our bookkeeping team is certified on QuickBooks Online and Xero, and we also work with FreshBooks, Wave and custom ERPs when needed.',
  },
  {
    id: 3,
    q: 'What happens if the CRA audits me after you file?',
    a: 'We represent you directly. Every WYSE Tribe client receives complimentary CRA correspondence support for any return we prepared, including handling pre-assessment reviews and full audits.',
  },
  {
    id: 4,
    q: 'Can you handle cross-border US and Canadian tax filings?',
    a: 'Absolutely. Our cross-border team files US 1040, FBAR, FATCA and Canadian T1/T2 returns side-by-side, applying treaty positions to avoid double taxation.',
  },
  {
    id: 5,
    q: 'How is WYSE Tribe different from a big-box tax shop?',
    a: 'We pair year-round advisory with secure cloud workflows. You get a dedicated advisor, transparent pricing and proactive planning \u2013 not a once-a-year transaction.',
  },
];

export const blogPosts = [
  {
    id: 1,
    slug: '2025-tfsa-contribution-room',
    title: '2025 TFSA Contribution Room \u2013 What\u2019s Changing',
    excerpt:
      'The TFSA limit moved again. Here\u2019s what Canadian savers should do this quarter to make the most of the new room.',
    image:
      'https://images.pexels.com/photos/6950031/pexels-photo-6950031.jpeg?auto=compress&cs=tinysrgb&w=900',
    date: { day: '14', month: 'Jan' },
    author: 'WYSE Tribe Team',
    category: 'Personal',
  },
  {
    id: 2,
    slug: 'corporate-class-or-holdco',
    title: 'Corporate Class Funds or a Holdco? A Founder\u2019s Guide',
    excerpt:
      'Which structure compounds wealth faster after tax \u2013 and which one quietly leaks returns. We break down the math.',
    image:
      'https://images.unsplash.com/photo-1686771416282-3888ddaf249b?crop=entropy&cs=srgb&fm=jpg&w=900&q=80',
    date: { day: '02', month: 'Feb' },
    author: 'Maya Chen, CPA',
    category: 'Corporate',
  },
  {
    id: 3,
    slug: 'cra-audit-defence-2025',
    title: 'The 7-Step CRA Audit Defence Playbook for 2025',
    excerpt:
      'Audits are up 19% YoY. Use this checklist to bullet-proof your records before any letter ever arrives.',
    image:
      'https://images.pexels.com/photos/6949525/pexels-photo-6949525.jpeg?auto=compress&cs=tinysrgb&w=900',
    date: { day: '21', month: 'Feb' },
    author: 'Daniel Okafor, CPA',
    category: 'Audit',
  },
];

export const team = [
  {
    id: 1,
    name: 'Karan Wyse',
    role: 'Founder & Lead Tax Advisor, CPA',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600&q=80&auto=format&fit=crop',
  },
  {
    id: 2,
    name: 'Maya Chen',
    role: 'Director of Corporate Tax, CPA',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80&auto=format&fit=crop',
  },
  {
    id: 3,
    name: 'Daniel Okafor',
    role: 'Audit & Assurance Lead, CPA',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80&auto=format&fit=crop',
  },
  {
    id: 4,
    name: 'Priya Sharma',
    role: 'Cross-Border Specialist',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&q=80&auto=format&fit=crop',
  },
];

export const heroImage =
  'https://customer-assets.emergentagent.com/job_wyse-tax/artifacts/cmca5r75_QueenImageDeuce.png';
export const aboutImage =
  'https://images.unsplash.com/photo-1772588627373-729b0f47e5bb?crop=entropy&cs=srgb&fm=jpg&w=1100&q=80';
export const aboutImageSmall =
  'https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&w=700&q=80';
export const comfortImage =
  'https://images.unsplash.com/photo-1714974528692-31aff2c54a62?crop=entropy&cs=srgb&fm=jpg&w=1100&q=80';
export const comfortImageSmall =
  'https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&w=600&q=80';
export const testimonialPortrait =
  'https://images.pexels.com/photos/6779567/pexels-photo-6779567.jpeg?auto=compress&cs=tinysrgb&w=900';
